import React from 'react';

const ListRowCheckbox = ({ selected, onClick }) => {
    return <React.Fragment>
        <div className="form-control-checkbox d-flex">
            <div className="form-checkbox">
                <input type="checkbox"
                    checked={selected}
                    value="checked"
                    onClick={onClick}
                    onChange={() => {
                    }}
                />
                <span className="check">
                    <i className="zmdi zmdi-check zmdi-hc-lg" />
                </span>
            </div>
        </div>
    </React.Fragment>;
};

export default ListRowCheckbox;


// WEBPACK FOOTER //
// ./components/ListRowCheckbox/index.js